import { gql } from '@apollo/client';

// financeiro-conciliacao-iugu Phase 5 (Task 4) -- documentos GraphQL grounded contra
// conciliacao.graphqls (backend, Task 2): 3 operações novas (2 queries, 1 mutation), todas
// ADMIN-only via @PreAuthorize no resolver (ConciliacaoGraphQL, Task 3). Mesmas convenções de
// financeiroService.ts: toda query/mutation é NOMEADA, nenhum `__typename` (test-utils.tsx monta
// o MockedProvider com addTypename={false}).

export const CONCILIACAO_IUGU = gql`
  query ConciliacaoIugu($inicio: Date!, $fim: Date!) {
    conciliacaoIugu(inicio: $inicio, fim: $fim) {
      gatewayDisponivel
      consultadoEm
      totalVerificado
      divergencias {
        pagamentoId
        invoiceId
        classe
        statusLocal
        statusRemoto
        valorLocal
        valorRemoto
        validadoIuguEm
        invoiceInexistenteEm
      }
    }
  }
`;

export const SALDO_CONTA_MESTRE_IUGU = gql`
  query SaldoContaMestreIugu {
    saldoContaMestreIugu
  }
`;

export const RECONCILIAR_PAGAMENTO = gql`
  mutation ReconciliarPagamento($pagamentoId: ID!) {
    reconciliarPagamento(pagamentoId: $pagamentoId) {
      resultado
      mensagem
      pagamento {
        id
        status
        validadoIuguEm
        invoiceInexistenteEm
      }
    }
  }
`;

// Espelha com.inplay.dto.financeiro.DivergenciaConciliacao (record) 1:1 -- ver
// conciliacao.graphqls (Task 2) para a razão de cada campo ser nullable.
export interface DivergenciaConciliacao {
  pagamentoId: string | null;
  invoiceId: string | null;
  classe: string;
  statusLocal: string | null;
  statusRemoto: string | null;
  valorLocal: number | null;
  valorRemoto: number | null;
  // Última vez que este pagamento bateu com a Iugu; null = nunca conciliado com sucesso.
  validadoIuguEm: string | null;
  // Preenchido quando a Iugu já respondeu 404 para este invoiceId — a linha não tem invoice no
  // gateway e a ação de reconciliar deixa de ser oferecida.
  invoiceInexistenteEm: string | null;
}

// Espelha com.inplay.dto.financeiro.ResultadoConciliacao (record) 1:1 -- quando
// gatewayDisponivel=false, divergencias vem sempre vazia e totalVerificado sempre 0 (AC-9,
// nunca resultado parcial).
export interface ResultadoConciliacao {
  gatewayDisponivel: boolean;
  consultadoEm: string;
  totalVerificado: number;
  divergencias: DivergenciaConciliacao[] | null;
}

export interface ConciliacaoIuguData {
  conciliacaoIugu: ResultadoConciliacao | null;
}

export interface ConciliacaoIuguVars {
  inicio: string;
  fim: string;
}

export interface SaldoContaMestreIuguData {
  saldoContaMestreIugu: number;
}

export interface PagamentoReconciliado {
  id: string;
  status: string;
  validadoIuguEm: string | null;
  invoiceInexistenteEm: string | null;
}

// Espelha com.inplay.enums.ResultadoReconciliacao. Desfechos ESPERADOS da reconciliação chegam
// como dado, não como erro GraphQL -- ver conciliacao.graphqls.
export type ResultadoReconciliacao =
  | 'ATUALIZADO'
  | 'JA_CONCILIADO'
  | 'INVOICE_INEXISTENTE'
  | 'SEM_INVOICE_LOCAL';

export interface ReconciliacaoResultado {
  resultado: ResultadoReconciliacao;
  mensagem: string;
  pagamento: PagamentoReconciliado;
}

export interface ReconciliarPagamentoData {
  reconciliarPagamento: ReconciliacaoResultado;
}

export interface ReconciliarPagamentoVars {
  pagamentoId: string;
}
